import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import { MissionTrackingListPage } from './mission-tracking-list'
import { MissionTrackingUpdatePage } from './mission-tracking-update'

const missionTrackingRoutes: Route[] = [
  {
    path: Paths.MISSION_TRACKING_LIST_PAGE,
    element: <MissionTrackingListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.MISSION_TRACKING_UPDATE_PAGE,
    element: <MissionTrackingUpdatePage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default missionTrackingRoutes
